import { render, staticRenderFns } from "./CustomMaterialIndex.vue?vue&type=template&id=02a94bc6&scoped=true"
import script from "./CustomMaterialIndex.vue?vue&type=script&lang=js"
export * from "./CustomMaterialIndex.vue?vue&type=script&lang=js"
import style0 from "./CustomMaterialIndex.vue?vue&type=style&index=0&id=02a94bc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a94bc6",
  null
  
)

export default component.exports